import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * This hook will be used to conditionally render translations based
 * on provided type of the element.
 *
 * @returns string | React.ReactNode
 */
export const useConditionalTranslation = () => {
  const { t } = useTranslation();

  const translate = (element: string | React.ReactNode) => {
    return typeof element === 'string' ? t(element) : element;
  };

  return translate;
};
